import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API, DOMAIN_HZW } from '@/service'
const api = {
  // home: `${utils.hostname('cms')}/publish/998/dingzhi.json`,
  // detail: `${utils.hostname('vitem')}/vdetailmain/VGetDetailMain`,
  detail: PREFIX_SCC_API + 'api/spu/queryCmmdtyDetail.do',
  oldSkuToNewSpu: PREFIX_SCC_API + 'api/spu/queryFchildSpuRela.do',
  question: `${utils.hostname('cms')}/publish/998/problemConfig.json`,
  explanation: `${utils.hostname('cms')}/publish/998/homeServiceConfig.json`,
  work: PREFIX_SCC_API + 'fchild/worker/workerListForConfirmOrder.do',
  workDay: PREFIX_SCC_API + 'fchild/worker/queryWorkerSchedule.do',
  workDayBySpu:
    PREFIX_SCC_API + 'fchild/worker/querySpuAndDistrictAllSchedule.do',
  getComments: `${utils.hostname('cmt')}/v1/czjyuer/comment/search/community`,
  // couponList: `${utils.hostname('kapi')}/KOPC-action/coupon4sku/getCouponList.do`,
  recmdList: `${utils.hostname('recommend')}/recommendsvc/RmdInGoodsDetail`,
  otherServiceList: DOMAIN_HZW + 'svses-api/api/queryCommodity.do',
  promotions: `${utils.hostname('cms')}/publish/999/promotions.json`,
  getShareImage: `//social.cekid.com/shequn-business/web/c/v1/shareimage` //社群接口 抓的孩子王app中的http://mytest.kapi.haiziwang.com:3003/project/2536/interface/api
}

export default {
  async getProductDetail({ commit }, query) {
    try {
      const product = await fetch(`${api.detail}?${query}`, {
        credentials: 'include'
      })
      const productJSON = await product.json()
      const queryObj = queryString.parse(query)
      const parseUrl = queryString.parseUrl(location.href)
      parseUrl.query.kwtarget = ''
      if (productJSON.data) {
        // 兼容门票商详跳转
        if (
          productJSON.data.spuType == 601 ||
          productJSON.data.spuType == 602
        ) {
          commit('setIsRedirect', true)
          location.replace(
            `//life.cekid.com/v2/ticket/detail/${
              queryObj.spuId
            }?${queryString.stringify(parseUrl.query)}`
          )
          return
        }
        //兼容教育品类权益卡
        if (productJSON.data.spuType == 701) {
          commit('setIsRedirect', true)
          location.replace(
            `//life.cekid.com/v2/education-card/detail/${
              queryObj.spuId
            }?${queryString.stringify(parseUrl.query)}`
          )
          return
        }
        if (productJSON.data.spuType == 801) {
          commit('setIsRedirect', true)
          location.replace(
            `//life.cekid.com/v2/education-tourism/detail/${
              queryObj.spuId
            }?${queryString.stringify(parseUrl.query)}&naviType=5`
          )
          return
        }
        // productJSON.data.cmmdtyVideo =
        //   'http://1400285498.vod2.myqcloud.com/fd58e52bvodcq1400285498/44ba1fb6387702305969820822/dJHFi9nBwaIA.mp4'
        // productJSON.data.cmmdtyVideoCover =
        //   'http://1400285498.vod2.myqcloud.com/d442d2d3vodtranscq1400285498/44ba1fb6387702305969820822/snapshotByTimeOffset/snapshotByTimeOffset_10_0.jpg'
        commit('commitProduct', productJSON.data)
        commit(
          'setIsCzjSpu',
          !(productJSON.data.spuType && productJSON.data.spuType === 402)
        )
        // 获取团信息
        if (productJSON.data.ruleDetail) {
          commit('setGroupInfo', productJSON.data.ruleDetail)
          if (productJSON.data.ruleDetail.groupList) {
            commit('setOtherGroupsList', productJSON.data.ruleDetail.groupList)
          }
        }
      }
      return productJSON
    } catch (e) {
      console.log(e)
    }
  },
  async getNewSpuBySku({ commit }, { skuId, empId }) {
    const query = queryString.stringify({
      skuId,
      empId
    })
    const res = await fetch(`${api.oldSkuToNewSpu}?${query}`)
    const json = await res.json()
    return json
  },
  async getMainConfig({ commit }) {
    try {
      const explanation = await fetch(api.explanation)
      const explanationJson = await explanation.json()
      if (explanationJson) {
        commit('setExplanation', explanationJson.data.serviceWarrantyDes)
        commit('setCommentDigest', explanationJson.data.commentDigest)
        commit('setQuestions', explanationJson.data.QA)
        commit('setTip', explanationJson.data.prompt)
        commit('setHotCity', explanationJson.data.hotCity)
        commit('setMainConfig', explanationJson.data)
      }
      return explanationJson
    } catch (e) {
      console.log(e)
    }
  },
  async getPagePromotions({ commit }) {
    try {
      const promotions = await fetch(api.promotions)
      const pJson = await promotions.json()
      return pJson
    } catch (e) {
      console.log(e)
    }
  },
  // 不分页获取服务人员
  async getWorkers(
    { commit, state },
    { spuId, districtId, serviceDate, storeCode }
  ) {
    try {
      const query_param = {
        spuId,
        districtId,
        serviceDate,
        storeCode
      }
      const query = queryString.stringify(query_param)
      const work_res = await fetch(`${api.work}?${query}`)
      const workJson = await work_res.json()
      if (workJson.code === '1') {
        const workers = workJson.data || []
        commit('setWorkers', workers)
      } else {
        throw new Error(workJson.code)
      }
    } catch (e) {
      throw new Error(e)
    }
  },
  async getComments({ commit }, { spuId, page, size, show_user }) {
    try {
      const query = queryString.stringify({
        page,
        size,
        object_id: spuId,
        show_user: 1,
        show_reply: 1
      })
      const comments_res = await fetch(`${api.getComments}?${query}`)
      const commentsJson = await comments_res.json()
      if (commentsJson.code === 1001) {
        if (page === 1) {
          commit('reSetComments', [])
        }
        commit('setComments', commentsJson.data.list)
        commit('setCommentCount', commentsJson.data.count)
        commit('setCommentPraiseRate', commentsJson.data.praiseRate)
      }
      return commentsJson
    } catch (e) {
      console.log(e)
    }
  },
  async getUserWorkDayBySpu(
    { commit, state },
    { spuId, districtId, month, workerCode }
  ) {
    try {
      const beginDate = new Date()
      const endDate = new Date(beginDate.setMonth(beginDate.getMonth() + month))
      const query = queryString.stringify({
        beginMonth: utils.dateFormat(new Date().getTime(), 'YY-MM'),
        endMonth: utils.dateFormat(endDate, 'YY-MM'),
        workerCode,
        spuId,
        districtId
      })
      const now_day = new Date().getDate()
      const otherDays = []
      for (let i = 1; i < now_day; i += 1) {
        const d = i < 10 ? `0${i}` : i
        otherDays.push(
          `${utils.dateFormat(new Date().getTime(), 'YY-MM')}-${d}`
        )
      }
      // console.log(otherDays);
      const days_res = await fetch(`${api.workDayBySpu}?${query}`)
      const daysJson = await days_res.json()
      const fullDays = []
      const workDays = []
      if (daysJson.code === '1') {
        const days = daysJson.data || []
        days.forEach(dayData => {
          // debugger;
          // console.log(dayData)
          const monthKey = Object.keys(dayData)[0]
          const arr = dayData[monthKey]
          // console.log(arr);
          const workDayArr = arr.filter(x => x === 0)
          if (workDayArr.length !== arr.length) {
            // 整个月都没排
            arr.forEach((ele, index) => {
              if (ele === 1) {
                const day = `${index + 1}`.padStart(2, '0')
                const workDay = `${monthKey}-${day}`
                if (!otherDays.includes(workDay)) {
                  workDays.push(workDay)
                }
              }
            })
          }
        })
        commit('setWorkDays', workDays)
      } else {
        throw new Error(daysJson.code)
      }
    } catch (e) {
      console.log(e.message)
      throw new Error(e)
    }
  },
  // 获取工作时间
  async getUserWorkDay({ commit, state }, { month, workerCode, startText }) {
    try {
      const beginDate = startText ? new Date(`${startText}-01`) : new Date()
      const copyBeginDate = new Date(beginDate.valueOf())
      const endDate = new Date(beginDate.setMonth(beginDate.getMonth() + month))
      // if (state.select)
      const query = queryString.stringify({
        beginMonth: utils.dateFormat(copyBeginDate, 'YY-MM'),
        endMonth: utils.dateFormat(endDate, 'YY-MM'),
        workerCode
      })
      const now_day = new Date().getDate()
      const otherDays = []
      for (let i = 1; i < now_day; i += 1) {
        const d = i < 10 ? `0${i}` : i
        otherDays.push(
          `${utils.dateFormat(new Date().getTime(), 'YY-MM')}-${d}`
        )
      }
      const days_res = await fetch(`${api.workDay}?${query}`)
      const daysJson = await days_res.json()
      const fullDays = []
      const workDays = []
      const setLookMonths = []
      if (daysJson.code === '1') {
        const days = daysJson.data || []
        days.forEach(ele => {
          if (ele.appointDays) {
            const otherDays_set = new Set(otherDays)
            const differenceABSet = new Set(
              [...ele.appointDays].filter(x => !otherDays_set.has(x.day))
            )
            const appointDays = Array.from(differenceABSet)
            appointDays.forEach(element => {
              workDays.push(element.day)
            })
          }
          if (ele.month) {
            setLookMonths.push(ele.month)
          }
        })
        commit('setLookMonths', setLookMonths)
        commit('setWorkDays', workDays)
        // commit('setFullDays', fullDays)
      } else {
        throw new Error(daysJson.code)
      }
    } catch (e) {
      console.log(e.message)
      throw new Error(e)
    }
  },
  async getRmdGoods(store, { uid, guid, skuid, pagenum, pagesize }) {
    try {
      const query = queryString.stringify({
        version: 'v1',
        storeid: 8000,
        uid,
        guid,
        skuid,
        pagenum,
        pagesize
      })
      const recmd_res = await fetch(`${api.recmdList}?${query}`, {
        // credentials: 'include'
      })
      const recmdJson = await recmd_res.json()
      return recmdJson
    } catch (e) {
      console.log(e)
    }
  },
  // 获取本店其他服务
  async getOtherServices({ commit }, { businessId, spuId, cityId }) {
    try {
      const recmd_res = await fetch(api.otherServiceList, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          businessId: [businessId],
          limit: 100,
          cityId,
          isSpec: 2
        })
      })
      const recmdJson = await recmd_res.json()
      if (recmdJson.code === '1') {
        const newList = recmdJson.data.list.filter(item => spuId != item.spuId)
        commit('setOtherServiceDatas', newList || [])
      }
      return recmdJson
    } catch (e) {
      throw new Error(e)
    }
  },
  async getShareImage(store, { imageUrl, price, product_name }) {
    const query_param = {
      source: 'HZWMALL_android',
      product_name,
      scene_id: 1,
      imageurl: imageUrl,
      entity_id: 8000,
      price
    }
    const query = queryString.stringify(query_param)
    const work_res = await fetch(`${api.getShareImage}?${query}`)
    const result = await work_res.json()
    return result.data
  }
}
